import React from "react"
import { Link } from "gatsby"

export default props => (
  <article
    className={`main-post-card ${props.count % 3 === 0 && `main-post-card-large`} ${
      props.postClass
    } ${props.node.frontmatter.thumbnail ? `with-image` : `no-image`}`}
    style={
      props.node.frontmatter.thumbnail && {
        backgroundImage: `url(${
          props.node.frontmatter.thumbnail.childImageSharp.fluid.src
        })`,
      }
    }
  >
    <Link to={props.node.fields.slug} className="main-post-card-link">
      <div className="main-post-card-content">
        <h2 className="main-post-card-title">
          {props.node.frontmatter.title || props.node.fields.slug}
        </h2>
      </div>
    </Link>
  </article>
)
